import React, { useState, Fragment, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { ReactEditor, useReadOnly, useFocused, useSelected, useSlate } from 'vendor/slate-react'
import { Transforms } from 'vendor/slate'
import { Button, FormControl, FormGroup } from 'react-bootstrap'
import SwaggerUI from 'swagger-ui-react'
import 'swagger-ui-react/swagger-ui.css'

const SwaggerWrapper = ({ attributes, children, element, editor }) => {
  const { url } = element
  const readOnly = useReadOnly()
  const [urlInputOpen, setUrlInputOpen] = useState(false)
  const [urlValue, setUrlValue] = useState(url)
  const path = ReactEditor.findPath(editor, element)

  return (
    <Wrapper>
      <SwaggerUrlDisplay contentEditable={false}>
        <SwaggerUI url={urlValue} />
      </SwaggerUrlDisplay>
      {!readOnly && (
        <SwaggerControlsAndUrlWrapper contentEditable={false}>
          <SwaggerControls>
            <SwaggerControlButton
              variant="secondary"
              size="sm"
              active={urlInputOpen}
              onClick={() => {
                setUrlInputOpen(!urlInputOpen)
              }}
            >
              <i className="fad fa-link" />
            </SwaggerControlButton>
          </SwaggerControls>
          <SwaggerControlsWrapper>
            {urlInputOpen && (
              <SwaggerUrl>
                <FormGroup className="mb-3">
                  <FormControl
                    size="sm"
                    as="input"
                    placeholder="Enter a swagger url"
                    value={urlValue || ''}
                    onChange={e => {
                      const { value } = e.target
                      if (value.includes('application/x-slate-clipboard:')) {
                        return
                      }
                      setUrlValue(value)
                    }}
                  />
                </FormGroup>
                <Button
                  size="md"
                  variant={url !== urlValue && urlValue && urlValue.length > 0 ? 'primary' : 'secondary'}
                  disabled={url === urlValue || !urlValue}
                  onClick={() => {
                    Transforms.setNodes(editor, { url: urlValue }, { at: path })
                  }}
                >
                  Save
                </Button>
              </SwaggerUrl>
            )}
          </SwaggerControlsWrapper>
        </SwaggerControlsAndUrlWrapper>
      )}
    </Wrapper>
  )
}
export default SwaggerWrapper

const Wrapper = styled.div`
  margin: 15px 0px;
`
const SwaggerUrlDisplay = styled.div`
  padding: 15px 10px;
  text-align: center;
`
const SwaggerControlsWrapper = styled.div``

const SwaggerControlsAndUrlWrapper = styled.div`
  margin: 15px 0px 15px 0px;
  width: 100%;
`

const SwaggerControls = styled.div`
  justify-content: space-between;
  width: 100%;
  display: flex;
`

const SwaggerControlButton = styled(Button)`
  color: ${props => props.theme.textGreyTinted}; !important;
  font-size: 11px;
  font-weight: bold;
`

const SwaggerUrl = styled.div`
  font-size: 16px;
  color: ${props => props.theme.textGreyTintedLighter};
  margin-top: 15px;
  margin-bottom: 10px;
  width: 100%;
  text-align: right;
  input::placeholder {
    color: ${props => props.theme.textGreyTintedLighter};
  }
`
